<div class="table-row-content" [@detailState]="visible ? 'visible' : 'hidden'">
  <ng-content></ng-content>
</div>
